// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1iR0P","location":"Header_location__FOchJ"};